/* Environment Map — Shared constants */
export var HEALTH_COLORS = { healthy: '#1D9E75', degraded: '#C8A030', error: '#E24B4A', unknown: '#3D5A70' };
export var EDGE_COLORS = { job: '#0ABFA3', webhook: '#4285F4', query: '#D4A574', transform: '#7F77DD', manual: '#3D5A70' };
export var CATEGORY_ICONS = { payment: '$', crm: 'C', devops: 'D', communication: 'M', storage: 'S', analytics: 'A', custom: 'K' };
export var LAYOUTS = [
  { value: 'force', label: 'Force' },
  { value: 'hierarchical', label: 'Hierarchy' },
  { value: 'circular', label: 'Circular' },
  { value: 'manual', label: 'Manual' },
];
export var CANVAS_W = 1200;
export var CANVAS_H = 600;
